export enum SteamErrorsEnum {
  STEAM_GUARD = 'steam guard is not enabled',
  STEAM_GUARD_HOLD = 'steam guard hold',
  STEAM_TRADE_BAN = 'steam trade ban',
  UNBINDING_STEAM = 'User without steam',
  INVALID_TRADELINK = 'invalid tradelink',
  PRIVATE_INVENTORY = 'private inventory',
  NO_TRADE_TOKEN = 'no trade token',
}
